/* ============================================================================
   MOTION ENHANCEMENTS — JS (AISLADO)
   ----------------------------------------------------------------------------
   Acompaña a motion-enhancements.css. Tres cosas, con guardas:
     1) Encoge el header al hacer scroll (clase .motion-header--scrolled).
     2) Rebote del contador del carrito cuando cambia (clase .motion-bump).
     3) Aparición al entrar en viewport, OPT-IN (solo elementos .motion-reveal).

   El reveal NO es global: únicamente los elementos a los que se les pone la
   clase .motion-reveal se animan (p. ej. las tarjetas de info). El resto del
   contenido NO se mueve al ir bajando.
   Para desactivar: quita la línea de carga en theme.liquid y borra el archivo.
   ============================================================================ */
(function () {
  'use strict';

  // -- 1) Header shrink al hacer scroll -------------------------------------
  var header = document.querySelector('.header-wrapper');
  var ticking = false;

  function update() {
    var y = window.scrollY || window.pageYOffset || 0;
    if (header) header.classList.toggle('motion-header--scrolled', y > 30);
    ticking = false;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  if (header) {
    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  // -- 2) Rebote del contador del carrito -----------------------------------
  var cartIcon = document.getElementById('cart-icon-bubble');

  function bump(bubble) {
    if (!bubble) return;
    bubble.classList.remove('motion-bump');
    void bubble.offsetWidth; // reflow para reiniciar la animación
    bubble.classList.add('motion-bump');
  }

  if (cartIcon && 'MutationObserver' in window) {
    var observer = new MutationObserver(function () {
      bump(cartIcon.querySelector('.cart-count-bubble'));
    });
    observer.observe(cartIcon, { childList: true, subtree: true, characterData: true });
  }

  // -- 3) Aparición al entrar en viewport (OPT-IN: elementos .motion-reveal) --
  var revealEls = document.querySelectorAll('.motion-reveal');
  if (revealEls.length) {
    var prefersReduce = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReduce || !('IntersectionObserver' in window)) {
      // Sin soporte / movimiento reducido: no ocultamos nada (se ven normales).
    } else {
      // Activamos el estado oculto AHORA que sabemos que hay JS. Sin esta clase
      // las tarjetas nunca se ocultan, así que nunca quedan invisibles si el JS
      // no corre. Viven bajo el fold => no se ve parpadeo.
      document.documentElement.classList.add('motion-reveal-on');

      var revObserver = new IntersectionObserver(function (entries, obs) {
        for (var k = 0; k < entries.length; k++) {
          var entry = entries[k];
          if (!entry.isIntersecting) continue;
          var el = entry.target;
          var idx = parseInt(el.getAttribute('data-reveal-i'), 10) || 0;
          var delay = Math.min(idx, 6) * 110; // escalonado, con tope
          (function (node, ms) {
            window.setTimeout(function () { node.classList.add('is-revealed'); }, ms);
          })(el, delay);
          obs.unobserve(el);
        }
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

      for (var r = 0; r < revealEls.length; r++) revObserver.observe(revealEls[r]);
    }
  }
})();
